import { render, staticRenderFns } from "./aistart.vue?vue&type=template&id=6aa1b976&scoped=true&"
import script from "./aistart.vue?vue&type=script&lang=js&"
export * from "./aistart.vue?vue&type=script&lang=js&"
import style0 from "./aistart.vue?vue&type=style&index=0&id=6aa1b976&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa1b976",
  null
  
)

export default component.exports